module.exports = __webpack_public_path__ + "img/onde-comprar.21ec410c.webp";